import React from 'react'

const CopyFileIcon = () => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        d="M10 0.625H2.5C1.8125 0.625 1.25 1.1875 1.25 1.875V10.625H2.5V1.875H10V0.625ZM11.875 3.125H5C4.3125 3.125 3.75 3.6875 3.75 4.375V13.125C3.75 13.8125 4.3125 14.375 5 14.375H11.875C12.5625 14.375 13.125 13.8125 13.125 13.125V4.375C13.125 3.6875 12.5625 3.125 11.875 3.125ZM5 13.125H11.875V4.375H5V13.125Z"
        fill="#B3B7C1"
      />
    </svg>
  )
}

export default CopyFileIcon
